module.exports = __webpack_public_path__ + "static/media/Invest.8071485c.png";